import React, {useState} from 'react';
import {Form, Button, Alert, Col} from 'react-bootstrap';
import {Formik} from 'formik';
import {useNavigate, useSearchParams, Link} from 'react-router-dom';

import axios from 'axios';
import {apiUrl} from '../util/Api';
import {setAuthentication, clearAuthentication} from '../util/Auth';

import {useDispatch} from 'react-redux';
import {saveUserStore, clearUserStore} from '../app/slices/UserSlice';

//import {string, object} from 'yup';
import * as Yup from 'yup';

const validationSchema = Yup.object({
  email: Yup.string().email('please enter a valid email').required('email is required'),
  password: Yup.string().min(8,'passwords need to be at least 8 characters').required('please enter a password'),
  tosAgree: Yup.boolean().oneOf([true], 'please accept the terms of service')
});

const Signup = () => {
  const [errors, setErrors] = useState([]);
  const [showLogin, setShowLogin] = useState(false);
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const showBetaKey = process.env.REACT_APP_BETA_REGISTER === 'true' ? true : false;

  const [searchParams] = useSearchParams();
  const inviteKey = searchParams.get('inviteKey') ? searchParams.get('inviteKey') : null;
  const regKey = searchParams.get('regKey') ? searchParams.get('regKey') : null;

  let params = (inviteKey ? `&inviteKey=${inviteKey}` : '') + (regKey ? `&regKey=${regKey}` : '')

  document.title = `reconify sign up`;

  const submitSubmit = (values, actions) => {
    //console.log("submitting form", values);
    setErrors([]);
    setShowLogin(false);
    //convert value from array here
    //var tosAgree = values.tosAgreeFlag ? (values.tosAgreeFlag === true ? 1 : 0) : 0;
    //values.tosAgree = tosAgree;

    //var mailAgree = values.mailAgreeFlag ? (values.mailAgreeFlag === true ? 1 : 0) : 0;
    //values.mailAgree = mailAgree;

    //var persist = values.persistFlag ? (values.persistFlag === true ? 1 : 0) : 0;
    //values.persist = persist;
    let persist = values.persist ? true : false;

    //timezone
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(timezone != null) {
      values.timezone = timezone;
    }

    //if invite - add to process
    if(inviteKey != null){
      values.inviteKey = inviteKey;
    }

    //if partner reg - add to process
    if(regKey != null){
      values.regKey = regKey;
    }

    //console.log('updated values:', values);

    axios.post(apiUrl + '/users/register', values, {withCredentials: true})
    .then((res) => {
      //console.log('logged in');
      //console.log("login results:", res.data);
      if(res.data.status === "ok" && res.data.user && res.data.user.userKey) {
        //console.log('about to set client cookie');
        //set cookie
        setAuthentication(res.data.user, persist);

        //dispatch?
        dispatch(saveUserStore(res.data.user));

        //console.log('redirect home');
        //redirect
        //history.push('/');
        if(inviteKey != null){
          navigate(`/account/${res.data.user.defaultAccountKey}/profile`);
        } else {
          navigate(`/account/${res.data.user.defaultAccountKey}`);
        }
      }
      else {
        //console.log('an error was returned');
        //display errors
        clearAuthentication();
        dispatch(clearUserStore());
        let errorMsgs = [];
        //reset TOS link?
        //values.tosAgree = [];
        res.data.errors.forEach((error, i) => {
          switch (error) {
            case 'email-missing':
              errorMsgs.push('Please enter an email.');
              break;
            case 'email-taken':
              errorMsgs.push('That email is already in use.');
              setShowLogin(true)
              break;
            case 'reg-not-found':
              errorMsgs.push('The AWS Marketplace registration was not found.');
              break;
            case 'reg-already-registered':
              errorMsgs.push('An account has already been created for this AWS Marketplace registration.');
              break;
            case 'password-missing':
              errorMsgs.push('Please enter a password.');
              break;
            case 'password-format':
              errorMsgs.push('Password must be 8 characters with at least one uppercase and one lowercase letter.');
              break;
            case 'tos-missing':
              errorMsgs.push('Please accept the Terms of Service.');
              break;
            case 'beta-token':
            case 'beta-token-missing':
              errorMsgs.push('Please enter a valid beta token.');
              break;
            case 'beta-token-used':
              errorMsgs.push('The token has already been used.');
              break;
            default:
              errorMsgs.push('There was an error creating the account.');
          }
        });
        setErrors(errorMsgs);
      }
    })
    .catch((err) => {
      //console.error(err);
      //console.log('something went wrong');
      clearAuthentication();
      dispatch(clearUserStore());
      setErrors(['An error occurred while creating the account.']);
    });
  }

  //check if logged in
  return (
    <Col xs={10} sm={8} md={6} className="public-component">
      <h3>Sign up</h3>
      <p>
        Use the form below to sign up for an account.
      </p>
      {showBetaKey ? (
        <p>
          If you do not currently have a Beta Access Key, you can <a href="https://www.reconify.com/beta" target="_blank" rel="noreferrer">request one here</a>. 
        </p>
      ) : null}
      {
        errors.length > 0 ? (
          <Alert variant='danger'>
          {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
          </Alert>
        ) : (null)
      }
      {
        showLogin === true ? (
          <Alert variant='info'>
            Already have an account? <Link to={`/login${params != "" ? "?" + params : ""}`}>Login</Link> 
          </Alert>
        ) : (null)
      }
    <Formik validationSchema={validationSchema}
      onSubmit={submitSubmit}
      initialValues={{email:'',password:'',betakey:'',persist:false,tosAgree:false,mailAgree:false}}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors
      }) => (
        <Form noValidate onSubmit={handleSubmit} className='col-md-9 col-sm-9 col-lg-9'>
          <Form.Group controlId='signup-email' className='mb-3'>
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" placeholder="email"
              name="email" value={values.email} onChange={handleChange}
              isInvalid={touched.email && errors.email}
            />
            <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId='signup-password' className='mb-3'>
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" placeholder="password"
              name="password" value={values.password} onChange={handleChange}
              isInvalid={touched.password && errors.password}
            />
            <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
          </Form.Group>
          {showBetaKey ? (
            <Form.Group controlId='signup-betakey' className='mb-3'>
              <Form.Label>Beta Access Key</Form.Label>
              <Form.Control type="text" placeholder="beta key"
                name="betakey" value={values.betakey} onChange={handleChange}
                isInvalid={touched.betakey && errors.betakey}
              />
              <Form.Control.Feedback type="invalid">{errors.betakey}</Form.Control.Feedback>
            </Form.Group>
          ) : null}

          <Form.Group controlId='signup-mail' className='mb-3'>
            <Form.Check type="checkbox" name="mailAgree" label="Sign up for newsletter" onChange={handleChange} value={true}/>
          </Form.Group>
          <Form.Group controlId='signup-tos' className='mb-3'>
            <Form.Check type="checkbox" name="tosAgree" label="Agree to Terms of Service" onChange={handleChange} value={true}
            isInvalid={touched.tosAgree && errors.tosAgree}/>
          </Form.Group>
          {/*<Form.Group controlId='signup-persist'>
            <Form.Check type="checkbox" name="persist" label="Stay logged in" onChange={handleChange} value={true}/>
          </Form.Group>*/}
          <Button variant="primary" type="submit">Sign up</Button>
        </Form>
      )}
    </Formik>
      
      <div className='mt-3 text-center'>
      <a href={process.env.REACT_APP_WEB_URL + '/tos'}  target='_blank' rel='noreferrer'><small>Terms of Service</small></a>
      </div>
      <div className="mt-3 text-center">
        Already have an account? <Link to={`/login${params != "" ? "?" + params : ""}`}>Login</Link>
      </div>
    </Col>
  );
}

export default Signup;
